module.exports = __webpack_public_path__ + "159063fff98cb948e9e2efb1047cdcf0.webp";